module.exports = __webpack_public_path__ + "img/jdjd.3982c39b.png";